import React from 'react';
import './SliderGoldPicker.sass'

class GoldPickerInput extends React.Component {
  state = {
    inputValue: this.props.value
  };

  timer = null;

  componentWillUnmount() {
      clearTimeout(this.timer);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.inputValue !== prevState.inputValue) {
      this.props.onChange(this.state.inputValue);
    }
    if (this.props.value !== prevProps.value) {
      setTimeout(() => {
          this.setState({ inputValue: this.props.value });
      }, 500);
    }
  }

  handleChange = (e) => {
    const inputValue = e.target.value;
    this.setState({ inputValue });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (inputValue < this.props.min) {
          this.setState({ inputValue: this.props.min });
      } else if (inputValue > this.props.max) {
          this.setState({ inputValue: this.props.max });
      } else {
          this.setState({ inputValue: inputValue });
      }
    },  500);
  };

  render() {
    const {unitLabel} = this.props;
    return (
      <div className="gold-slider__input-wrapper">
        <label className="field-text__name" htmlFor="goldpicker">{unitLabel}</label>
        <input
          name="goldpicker"
          id="goldpicker"
          className="field-text__input"
          type="number"
          value={this.state.inputValue}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default GoldPickerInput;


// WEBPACK FOOTER //
// ./components/productVariants/goldPickers/GoldPickerInput.js